import React, { useEffect } from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import './App.css';
import TopNavBar from './components/Layout/TopNavBar';
import LandingPage from './components/LandingPage/LandingPage';
import Explore from './components/Explore/Explore';
import Index from './components/Index/Index';
import Compose from './components/Compose/Compose';
import Search from './components/Search/Search';
import ResilienceSearchV1 from './components/Resilience/archive/ResilienceV1';
import CollectPortfolioForm from './components/Resilience/CompanyAsset';
import Account from './components/Account/Account';
import ProtectedRoute from "./routes/ProtectedRoute";
import ChangePassword from "./components/Account/ChangePassword";
import {AuthProvider} from "./context/authContext";
import UserProfile from "./components/Account/Profile";
import PasswordReset from "./components/Account/PasswordReset";
import PasswordResetDone from "./components/Account/PasswordResetDone";
import Login from "./routes/login/Login";
import Logout from "./routes/logout/Logout";
import PortfolioList from "./components/Layout/PortfolioList";
import CorporateRiskDashboard from "./components/Resilience/CorporateRiskDashboard";


function App() {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [selectedProject, setSelectedProject] = React.useState(localStorage.getItem("project"));
  const LOGIN = '/login';

  useEffect(() => {
    localStorage.setItem("project", selectedProject);
  }, [selectedProject]);

  return (
      <Router>
        <AuthProvider>
          <div >
            {/* <BaseContainer> */}
            <TopNavBar selectedProject={selectedProject} setSelectedProject={setSelectedProject}/>
            <Routes>
              <Route path="/" element={<LandingPage
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
              />} />
              {/* <Route path="/" element={<Navigate replace to="/index" />} /> */}
              <Route path="/explore" element={<ProtectedRoute redirectPath={LOGIN}><Explore /></ProtectedRoute>}/>
              <Route path="/index" element={<ProtectedRoute redirectPath={LOGIN}><Index selectedProject={selectedProject}/></ProtectedRoute>}/>
              <Route path="/compose" element={<ProtectedRoute redirectPath={LOGIN}><Compose selectedProject={selectedProject}/></ProtectedRoute>}/>
              <Route path="/search" element={<ProtectedRoute redirectPath={LOGIN}><Search selectedProject={selectedProject}/></ProtectedRoute>}/>
              <Route path="/resilience" element={<ProtectedRoute redirectPath={LOGIN}><ResilienceSearchV1 project={selectedProject}/></ProtectedRoute>}/>
              <Route path="/corporate" element={<ProtectedRoute redirectPath={LOGIN}><CorporateRiskDashboard project={selectedProject}/></ProtectedRoute>}/>
              <Route path="/assets" element={<ProtectedRoute redirectPath={LOGIN}><CollectPortfolioForm project={selectedProject}/></ProtectedRoute>}/>
              <Route path="/portfolios" element={<ProtectedRoute redirectPath={LOGIN}><PortfolioList selectedProject={selectedProject}/></ProtectedRoute>}/>

              <Route path="/account" element={<ProtectedRoute redirectPath={LOGIN}><Account /></ProtectedRoute>}/>
              <Route path={LOGIN} element={<Login/>}/>
              <Route path="/logout" element={<Logout/>}/>
              <Route path="/account/password_reset" element={<PasswordReset/>}/>
              <Route path="/account/password_reset/done" element={<PasswordResetDone/>}/>
              <Route path="/account/password" element={<ProtectedRoute redirectPath={LOGIN}><ChangePassword /></ProtectedRoute>}/>
              <Route path="/account/profile" element={<ProtectedRoute redirectPath={LOGIN}><UserProfile /></ProtectedRoute>}/>
            </Routes>
            {/* </BaseContainer> */}
          </div>
        </AuthProvider>
      </Router>
  );
}

export default App;
